import { CompanyNameCell } from "app/pages/sales-intelligence/common-components/table-cells";
import { createCompanyPageLink } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/helpers/routing";

import type { ContactSearchEntry } from "../../../types/common";
import { StyledBlockBaseCell } from "../styles";

interface IProps {
    rowData: ContactSearchEntry;
}

const ContactCompanyNameCell = ({ rowData }: IProps) => {
    const overviewLink = createCompanyPageLink({
        key: rowData.site,
        isWWW: "*",
    });

    return (
        <StyledBlockBaseCell>
            <CompanyNameCell
                iconSrc={rowData.favicon}
                overviewLink={overviewLink}
            >
                {rowData.companyName || rowData.site}
            </CompanyNameCell>
        </StyledBlockBaseCell>
    );
};

export default ContactCompanyNameCell;
